export enum WorkflowStatusActions {
  ReadyForPublicHearing = 1,
  PublicHearingAdopt = 2,
  PublicHearingReject = 3,
  AGApprove = 4,
  AGReject = 5,
  AGReturnToAgency = 6,
  SubmitToAGForReviewAfterAGRejection = 7,
  GPROApprove = 8,
  GPROReject = 9,
  GPROReturnToAgency = 10,
  SubmitToAGForReviewAfterGPRORejection = 11,
  ReadyForPromulgation = 12,
  SubmitToAGForReview = 13,
  Promulgated = 14,
  SubmitEmergencyFilingToGPROForReview = 15,
  GPROApproveEmergencyFiling = 16,
  GPROReturnEmergencyFilingToAgency = 17,
  ResubmitEmergencyFilingToGPROForReview = 18,
  SOSNotifyAgencyOfChanges = 19,
  NonSubstantiveSOSNotifyAgencyOfChanges = 20,
  EmergencySOSNotifyAgencyOfChanges = 21,
  PublicHearingSOSNotifyAgencyOfChanges = 22
}